import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERITAGE = "https://customer-assets.emergentagent.com/job_gem-catalogue/artifacts/1710wg27_IMG_4608.jpg";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-20">
      <div className="ornament mb-4">About</div>
      <h1 className="font-display text-5xl md:text-6xl text-navy-900 leading-tight" style={{ fontWeight: 500 }}>
        A house of <em className="text-gold" style={{ fontStyle: 'italic' }}>quiet craftsmanship</em>.
      </h1>
      <div className="grid md:grid-cols-2 gap-14 mt-14">
        <div className="aspect-[4/5] overflow-hidden border border-gold/40">
          <img src={HERITAGE} alt="Bholaa Jewels heritage" className="w-full h-full object-cover" />
        </div>
        <div className="space-y-5 text-navy-900/80 leading-relaxed">
          <p>
            Established in 1966 in Sector 8-B, Chandigarh, by a family of generational jewellers,
            Bholaa Jewels began as one of the city&apos;s pioneering jewellery showrooms. Today, four
            generations later, it remains a family-led jewel house built not on promotion, but on
            reputation — earned through trust, discretion, and enduring relationships with
            generations of patrons.
          </p>
          <p>
            Every creation reflects our exclusive standards. Gold jewellery is hallmarked for assured
            purity, while every diamond is certified by respected institutions such as IGI and GIA.
            Our pricing is transparent and straightforward, based on the prevailing market gold rate
            of the day — free from seasonal markups, hidden charges, or unnecessary premiums.
          </p>
          <p>
            We do not create jewellery for a season. We create heirlooms — pieces designed to be worn
            every day with confidence, treasured for a lifetime, and passed on with pride to future
            generations.
          </p>
          <Link to="/catalogue" className="inline-flex items-center gap-2 mt-4 text-gold hover:text-gold-dark tracking-widest text-sm uppercase" data-testid="about-cta">
            Browse the catalogue <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
